import moment from 'moment';
import { getLookupObject } from '../../../utils/table';
import { getColumns } from '../tabsAccounting/tableBuysHelper';

export const getDataURL = (url, {
  year, source, strategyId, portfId, projId,
}, isExport = false) => {
  const searchParams = new URLSearchParams();
  if (year) searchParams.append('year', year);
  if (source) searchParams.append('type', source);
  if (strategyId) searchParams.append('strategyId', strategyId);
  if (portfId) searchParams.append('portfId', portfId);
  if (projId) searchParams.append('projId', projId);

  const baseUrl = `${url}${isExport ? '/export' : ''}?`;
  const searchParamsString = searchParams.toString();

  return baseUrl + searchParamsString;
};

export const getExportFileName = (baseFilename) => {
  const timestampString = `от ${moment().format('DD.MM.YYYY')}`;
  return `${baseFilename} ${timestampString}.xlsx`;
};

// todo
export const getFilters = (data) => {
  const columnsMetadata = getColumns({})
    .filter((col) => col._meta && col._meta.lookup)
    .map((col) => ({ field: col.field, lookupLabelsDictionary: col._meta.lookupLabelsDictionary }));

  return columnsMetadata.reduce((acc, col) => {
    const result = getLookupObject(data, col.field);
    if (col.lookupLabelsDictionary) {
      for (const key of Object.keys(result)) { result[key] = col.lookupLabelsDictionary[key]; }
    }

    return { ...acc, [col.field]: result };
  }, {});
};
